let featuredSwiper;
const HOME_HERO_IMAGE_COUNT = 1
let loadedHeroImages = 0

$('.custom-home-capsules-block').ready(() => {
  if (!$('html').hasClass('template-index')) return;

  const heroBlock = $('.custom-home-capsules-block-content');

  heroBlock.on('heroLoaded', function() {
    const wrapper = $(this);
    if(wrapper.hasClass('content-loaded')) return;

    const images = wrapper.find('img.lazyloaded');
    if(images.length !== HOME_HERO_IMAGE_COUNT && loadedHeroImages < HOME_HERO_IMAGE_COUNT) return;

    wrapper.addClass('content-loaded');
  })
})

$(document).ready(() => {
  if (!$('html').hasClass('template-index') && !$('html').attr('class').includes('template-page-index-seo-template')) return;

  const heroBlock = $('.custom-home-capsules-block-content');

  //trigger hero section transitions if images were chached
  $('.custom-home-capsules-block-content img').one("load", () => {
    loadedHeroImages = loadedHeroImages + 1;
    heroBlock.trigger('heroLoaded')
  }).each(function() {
    if (this.complete || this.complete === undefined){
      $(this).trigger('load');
    }
  });

  // honeycomb slider ---------->
  new Swiper ('.swiper-container.honeycomb', {
    // speed: 1000,
    // spaceBetween: 30,
    centeredSlides: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   stopOnLastSlide: true,
    // },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    keyboard: true,
    freeMode: true,
    threshold: 1,
    longSwipes: false,
    // pagination: {
    //   el: '.swiper-pagination',
    // },
  });
  // <---------- honeycomb slider

  // sets slider ---------->
  new Swiper ('.swiper-container.sets', {
    spaceBetween: 30,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    keyboard: true,
    freeMode: true,
    threshold: 1,
    longSwipes: false,
  });
  // <---------- sets slider

  const animationCount = $('.new-home-animation-content').length
  $('.new-home-animation-content video').on('ended', nextVideoOnEnded)
  function nextVideoOnEnded() {
    const index = $(this).closest('.new-home-animation-content').data('index')
    const nextIndex = index + 1 >= animationCount ? 0 : index + 1
    $('.new-home-animation-content, .new-home-animation-header .card').removeClass('active')
    $(`.new-home-animation-content[data-index="${nextIndex}"]`).addClass('active').find('video')[0].play()
    $(`.new-home-animation-header .card[data-index="${nextIndex}"]`).addClass('active')
  }

  $('.new-home-animation-header .card').on('click', function() {
    $('.new-home-animation-content video').off('ended', nextVideoOnEnded)
    const index = $(this).data('index')
    $('.new-home-animation-header .card').removeClass('active')
    $(this).addClass('active')
    $('.new-home-animation-content').removeClass('active')
    $(`.new-home-animation-content[data-index="${index}"]`).addClass('active').find('video').get(0).play()
  })
});

// img-text-btn slider ---------->
// vars
let currentImgTextBtnSlide = 0;
let currentLeftPhraseIndex = 0;
let currentRightPhraseIndex = -1;
const slideImgTextBtnAnimationDuration = 1000;

function slideImgTextBtnChange() {
  const fadeDuration = 150;
  const leftPhraseContainers = $('.common-img-text-btn-block-content-header-left');
  const rightPhraseContainers = $('.common-img-text-btn-block-content-header-right');

  // change phrase
  (function phraseChange(container = 'both', changeImage = false) {
    if (container === 'left') {
      if ((currentLeftPhraseIndex + 1) % 3 === 0) {
        currentRightPhraseIndex++;
        $(rightPhraseContainers[currentRightPhraseIndex]).fadeIn(fadeDuration);
        setTimeout(() => phraseChange('both'), slideImgTextBtnAnimationDuration);
      } else {
        // $(leftPhraseContainers[currentLeftPhraseIndex]).fadeOut(fadeDuration);
        setTimeout(() => $(leftPhraseContainers[currentLeftPhraseIndex - 1]).fadeOut(fadeDuration), fadeDuration / 2);
        currentLeftPhraseIndex++;
        // setTimeout(() => $(leftPhraseContainers[currentLeftPhraseIndex]).fadeIn(fadeDuration / 2), fadeDuration / 2);
        $(leftPhraseContainers[currentLeftPhraseIndex]).fadeIn(fadeDuration);
        setTimeout(() => phraseChange('left', (currentLeftPhraseIndex + 1) % 3 === 0), slideImgTextBtnAnimationDuration);
      }
    } else if (container === 'right') {
      if ((currentRightPhraseIndex + 1) % 12 === 0) {
        $(rightPhraseContainers[currentRightPhraseIndex]).fadeOut(fadeDuration);
        currentLeftPhraseIndex = 0;
        currentRightPhraseIndex = -1;
        $(leftPhraseContainers[currentLeftPhraseIndex]).fadeIn(fadeDuration);
        setTimeout(() => phraseChange('left'), slideImgTextBtnAnimationDuration);
      } else if ((currentRightPhraseIndex + 1) % 4 === 0) {
        currentLeftPhraseIndex++;
        $(rightPhraseContainers[currentRightPhraseIndex]).fadeOut(fadeDuration);
        $(leftPhraseContainers[currentLeftPhraseIndex]).fadeIn(fadeDuration);
        setTimeout(() => phraseChange('left'), slideImgTextBtnAnimationDuration);
      } else {
        // $(rightPhraseContainers[currentRightPhraseIndex]).fadeOut(fadeDuration);
        setTimeout(() => $(rightPhraseContainers[currentRightPhraseIndex - 1]).fadeOut(fadeDuration), fadeDuration / 2);
        currentRightPhraseIndex++;
        $(rightPhraseContainers[currentRightPhraseIndex]).fadeIn(fadeDuration);
        setTimeout(() => phraseChange('right', (currentRightPhraseIndex + 1) % 4 === 0), (currentRightPhraseIndex + 1) % 4 === 0 ? slideImgTextBtnAnimationDuration * 2 : slideImgTextBtnAnimationDuration);
      }
    } else {
      $(leftPhraseContainers[currentLeftPhraseIndex]).fadeOut(fadeDuration);
      // $(rightPhraseContainers[currentRightPhraseIndex]).fadeOut(fadeDuration);
      setTimeout(() => $(rightPhraseContainers[currentRightPhraseIndex - 1]).fadeOut(fadeDuration), fadeDuration / 2);
      currentRightPhraseIndex++;
      $(rightPhraseContainers[currentRightPhraseIndex]).fadeIn(fadeDuration);
      setTimeout(() => phraseChange('right'), slideImgTextBtnAnimationDuration);
    }

    if (changeImage) imageChange();
  })('left');

  // change img
  function imageChange() {
    // const containersCount = 2;
    // const i = currentImgTextBtnSlide % containersCount;
    // const y = parseInt(currentImgTextBtnSlide / containersCount, 10);

    // $($($('.common-img-text-btn-block-img')[i]).find('img')[y]).hide();
    // $($($('.common-img-text-btn-block-img')[i]).find('img')[y === containersCount ? 0 : y + 1]).show();
    // currentImgTextBtnSlide = currentLeftPhraseIndex === 0 ? 0 : currentImgTextBtnSlide + 1;

    $($('.common-img-text-btn-block-img > img')[currentImgTextBtnSlide]).hide();
    currentImgTextBtnSlide = currentLeftPhraseIndex === 0 ? 0 : currentImgTextBtnSlide + 1;
    $($('.common-img-text-btn-block-img > img')[currentImgTextBtnSlide]).addClass('custom-loaded');
    $($('.common-img-text-btn-block-img > img')[currentImgTextBtnSlide]).show();
  }
};
// <---------- img-text-btn slider

// routines ---------->
$('[data-routine-tab]').click(function() {
  $('[data-routine-tab]').removeClass('active');
  $(this).addClass('active');
  const stories = $('.custom-home-routine-story');
  const oldStory = $('.custom-home-routine-story.active');
  const newStory = $(stories[$(this).index()]);
  oldStory.fadeOut(300, function () {
    oldStory.removeClass('active');
    newStory.fadeIn(300, function () {
      newStory.addClass('active');
    });
  });
})
$('.select-routine-tab').change(function(e) {
  $('[data-routine-tab]').removeClass('active');
  $(this).eq(e.target.value).addClass('active');
  const stories = $('.custom-home-routine-story');
  const oldStory = $('.custom-home-routine-story.active');
  const newStory = $(stories[e.target.value]);
  oldStory.fadeOut(300, function () {
    oldStory.removeClass('active');
    newStory.fadeIn(300, function () {
      newStory.addClass('active');
    });
  });
})
$('[data-routine-pic-switch] span').click(function() {
  $('[data-routine-pic-switch] span').toggleClass('active');
  $('.custom-home-routine-storyPics img').toggleClass('active');
})
$('.custom-home-routine-storySystem').click(function() {
  if(isDesktop()) return

  $(this).find('.custom-home-routine-systemContentSwitch').toggleClass('active');
  $(this).find('.custom-home-routine-systemContent').slideToggle("slow");
})
/*$('.custom-home-routine-systemContentSwitch').click(function() {
  $(this).toggleClass('active');
  $(this).closest('.custom-home-routine-storySystem').find('.custom-home-routine-systemContent').slideToggle("slow");
})*/
// <---------- routines
